import reducers from './reducers';
import { configureStore } from '@reduxjs/toolkit';
import { listenerMiddleware } from './listenerMiddleware';

function configure(initialState) {

  const store = configureStore({
    reducer: reducers,
    initialState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: {
        ignoredActionPaths: ['payload.navigate', 'payload.location', 'payload.history']
      }
    }).prepend(listenerMiddleware.middleware)
  })

  if (process.env.NODE_ENV !== 'production' && module.hot) {
    module.hot.accept('./reducers', () => store.replaceReducer(reducers))
  }

  return store;
}
const store = configure();
export default store;
